module.exports = __webpack_public_path__ + "media/images/product/f_i-4653e5ef70006c85d20c1112a03d7543.png";